import { css } from '@emotion/css';
import { Color, FontWeight, Spacing } from 'src/styles';

export const description = css`
  background-color: ${Color.Orange1};
`;

export const text = css`
  && {
    ${Spacing.mr4}
  }
`;

export const viewMoreButton = css`
  color: ${Color.Orange7};
  background-color: ${Color.Orange1};
  ${FontWeight.bold}

  &:hover:not(:focus) {
    color: ${Color.Orange7};
  }
`;
